import { kebabCase } from 'lodash';

import { recursiveCaseTransform } from './recursiveCaseTransform';
import type { JSONData } from './types';

export function toKebabCase<T extends JSONData>(sourceObj: JSONData): T {
  return recursiveCaseTransform<T>(sourceObj, kebabCase);
}
